import axios from "@/http"
export default {
  name:"competitionClub",
  listCompetitionClub(param){
    return axios({
      url: '/api/v1/extra/competition/competitions',
      method: 'GET',
      params: param
    })
  },
  listCompetitionClubNotice(param){
    return axios({
      url: '/api/v1/extra/competition/notices',
      method: 'GET',
      params: param
    })
  },
  listCompetitionClubFile(param){
    return axios({
      url: '/api/v1/extra/competition/files',
      method: 'GET',
      params: param
    })
  },
  listCompetitionClubArticle(query) {
    return axios({
      url: '/api/v1/extra/competition/articles?prelaod=true',
      method: 'GET',
      params: query
    })
  },
  listCompetitionTakers(query){
    return axios({
      url: '/api/v1/extra/competition/relation/competitionparticipants?prelaod=true',
      method: 'GET',
      params: query
    })
  },
  createCompetitionClub(data){
    return axios({
      url: '/api/v1/extra/competition/competitions',
      method: 'POST',
      data
    })
  },
  createCompetitionFile(data){
    return axios({
      url: '/api/v1/extra/competition/files',
      method: 'POST',
      data
    })
  },
  getCompetitionClub(id){
    return axios({
      url: '/api/v1/extra/competition/competitions/' + id,
      method: 'get',
      params:{ id, preload:true }
    })
  },
  getCompetitionFile(query){
    return axios({
      url: '/api/v1/extra/competition/files',
      method: 'get',
      params: query
    })
  },
  updateCompetition(data){
    return axios({
      url: '/api/v1/extra/competition/competitions/' + data.id,
      method: 'put',
      params: data.where?{where: data.where}: undefined,
      data
    })
  },
  deleteCompetitionFile(id){
    return axios({
      url: '/api/v1/extra/competition/files/' + id,
      method: 'delete'
    })
  },
  updateAnnounce(data){
    return axios({
      url: '/api/v1/extra/competition/notices/' + data.id,
      method: 'put',
      params: data.where?{where: data.where}: undefined,
      data
    })
  },
  createAnnounce(data) {
    return axios({
      url: '/api/v1/extra/competition/notices',
      method: 'POST',
      data
    })
  },
  createCompetitionArticle(data){
    return axios({
      url: '/api/v1/extra/competition/articles',
      method: 'post',
      data
    })
  },
  createCompetitionArticleAttachments(data){
    return axios({
      url: '/api/v1/extra/competition/attachments',
      method: 'post',
      data
    })
  },
  getCompetitionArticle(id){
    return axios({
      url: '/api/v1/extra/competition/articles/' + id,
      method: 'get',
      params:{ id, preload:true }
    })
  },
  updateCompetitionArticle(data) {
    return axios({
      url: '/api/v1/extra/competition/articles/' + data.id,
      method: 'put',
      params: data.where?{where: data.where}: undefined,
      data
    })
  },
  deleteCompetitionArticleAttachments(id){
    return axios({
      url: '/api/v1/extra/competition/attachments/' + id,
      method: 'delete',
    })
  },
  deleteCompetitionClub(id) {
    return axios({
      url: '/api/v1/extra/competition/competitions/' + id,
      method: 'delete'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/axj-extracurricular/axj-competition-club-api.js